import React, {FC} from "react"
import styled from "styled-components"
import {omit} from "lodash"

import {spacingCss, SpacingProps} from "../global/css"
import {iconPicker, isChevron} from "./helpers"
import IconTypes from "./IconTypes.enum"

export interface IconProps extends SpacingProps {
  icon: IconTypes
  id?: string
  size?: number
  color?: string
  small?: boolean
  large?: boolean
  extraLarge?: boolean
  block?: boolean
  strokeWidth?: number
}

// Spacing props are consumed by the styled wrapper below (via spacingCss) and
// must NOT be forwarded to the underlying glyph: react-icons components spread
// unknown props onto their <svg> DOM node, which triggers warnings such as
// "React does not recognize the `marginLeft` prop on a DOM element".
const spacingPropKeys = [
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "gap"
] as const

const IconComponent: FC<IconProps> = (props) => {
  const {extraLarge, large, small, size, icon, block, ...rest} = props

  // by default, Icons follow same dimensions as fonts in buttons
  let iconSize = 16
  const display = block ? "block" : "inline"

  if (large) iconSize = 18
  if (extraLarge) iconSize = 20
  if (small) iconSize = 14

  // if the icon is a chevron, we want it to look smaller than the other icons
  if (isChevron(icon)) iconSize -= 6

  if (size) iconSize = size

  const Icon = iconPicker(icon)
  return <Icon display={display} size={iconSize} {...omit(rest, spacingPropKeys)} />
}

export default styled(IconComponent)`
  ${spacingCss}
`
export {default as IconTypes} from "./IconTypes.enum"
